import { motion } from "framer-motion";
import { fadeUp, viewportOnce } from "../../lib/motion";
import { SECTORS } from "../../lib/sectors";
import { StatusLabel, TypesList } from "./SectorParts";

const sector = SECTORS[2];

const SectorIndustrial = () => (
    <section
        data-testid="sector-industrial-section"
        className="relative bg-surface/40 py-24 lg:py-32"
    >
        <div className="mx-auto max-w-[1600px] px-6 md:px-10 lg:px-16">
            <motion.figure
                variants={fadeUp}
                initial="hidden"
                whileInView="show"
                viewport={viewportOnce}
                className="group relative overflow-hidden"
            >
                <img
                    src={sector.image}
                    alt={sector.alt}
                    loading="lazy"
                    className="aspect-[16/9] w-full object-cover transition-transform duration-700 group-hover:scale-[1.04] lg:aspect-[21/9]"
                />
                <figcaption className="absolute bottom-0 left-0 bg-[#0A0F1D]/85 px-4 py-2 font-mono text-[13px] tracking-[0.22em] text-mist backdrop-blur-sm">
                    {sector.caption}
                </figcaption>
            </motion.figure>

            <motion.div
                variants={fadeUp}
                initial="hidden"
                whileInView="show"
                viewport={viewportOnce}
                className="mt-12 grid gap-10 lg:grid-cols-12 lg:gap-16"
            >
                <div className="lg:col-span-4">
                    <div className="flex flex-wrap items-center gap-4">
                        <span className="font-mono text-[13px] tracking-[0.3em] text-cad">
                            {sector.n}
                        </span>
                        <StatusLabel
                            tier={sector.tier}
                            id="sector-status-industrial"
                        >
                            {sector.status}
                        </StatusLabel>
                    </div>
                    <h2
                        data-testid="sector-industrial-headline"
                        className="mt-6 font-display text-3xl font-semibold leading-[1.1] text-white md:text-4xl"
                    >
                        {sector.title}
                    </h2>
                </div>
                <div className="lg:col-span-8">
                    <p className="max-w-3xl text-[16px] leading-relaxed text-mist">
                        {sector.copy}
                    </p>
                </div>
            </motion.div>

            <TypesList
                types={sector.types}
                idPrefix="sector-industrial"
                cols={3}
                className="mt-12 border-t border-white/10 pt-6"
            />
        </div>
    </section>
);

export default SectorIndustrial;
